// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonFilterField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { forEach, omit } from 'lodash/fp';
import ObjectStateConstants from 'logic/data/Izenda.ObjectStateConstants';
import { action, observable } from 'mobx';

export default class CommonFilterField {
  @observable id: string = '';
  @observable name: string = '';
  @observable displayName: string = '';
  @observable value: string = '';
  @observable defaultValue: string = '';
  @observable operatorId: string = '';
  @observable operatorSetting = null;
  @observable dashboardId: string = null;
  @observable filterFields = [];
  @observable filterFieldsMapping = [];
  @observable state: number = ObjectStateConstants.UPDATE;
  @observable position: number = 0;
  @observable cascading: boolean = false;
  @observable required: boolean = false;

  constructor(data: any) {
    data && this.populateData(data);
  }

  /**
   * build data for save
   * @method buildDataForSave
   * @return {Object}         common filter field data
   */
  buildDataForSave = () => {
    return omit('filterFieldsMapping', this);
  };

  /**
   * Populate common filter field data to model
   * @param {Object} common filter field data
   */
  @action
  populateData(data: any): void {
    this.name = data.name;
    this.displayName = data.displayName;
    this.value = data.value;
    this.defaultValue = data.value;
    this.operatorId = data.operatorId;
    this.operatorSetting = data.operatorSetting;
    this.filterFields = data.filterFields;
    this.id = data.id;
    this.position = data.position;
    this.cascading = data.cascading;
    this.required = data.required;
  }

  /**
   * Update operator id
   * @param  {String} id
   */
  @action
  setOperatorValue(id: string): void {
    this.operatorId = id;
    forEach((item) => {
      item.setOperatorId(id);
    }, this.filterFieldsMapping);
  }

  /**
   * Update common filter value and all filter in dashboard
   * @method setFilterValue
   * @param  {String}       filterValue [description]
   */
  
  setFilterValue = action((filterValue: string): void => {
    this.value = filterValue;
    forEach((item) => {
      item.setFilterValue(filterValue);
    }, this.filterFieldsMapping);
  })
}



// WEBPACK FOOTER //
// ./ui/logic/models/Dashboard/Izenda.CommonFilterField.js